import { defineComponent } from 'vue';
import BellSlash from '../../assets/icons/bell-slash.svg.js';
import __vue_component__ from './Tag/Tag.vue.js';

var script = defineComponent({
    name: 'UnsubscribedTag',
    components: {
        BellSlash,
        Tag: __vue_component__,
    },
});

export { script as default };
